import { Database } from '@vuex-orm/core';
import Wizard from '@/orm/models/Wizard/Wizard';
import VacancySettings from '@/orm/models/Vacancy/VacancySettings';
import Currency from '@/orm/models/Dictionary/Currency';
import CountryCurrency from '@/orm/models/Country/CountryCurrency';
import Account from '@/orm/models/Account/Account';
import Plan from '@/orm/models/Account/Plan';
import Period from '@/orm/models/Account/Period';
import Transaction from '@/orm/models/Account/Transaction';
import BillingPayment from '@/orm/models/Account/BillingPayment';
import PaymentMethod from '@/orm/models/Account/PaymentMethod';
import QuotaPrice from '@/orm/models/Account/QuotaPrice';
import VacanciesList from '@/orm/models/VacanciesList/VacanciesList';
import VacanciesListVacancies from '@/orm/models/VacanciesList/VacanciesListVacancies';
import CompanyTemplateSettings from '@/orm/models/Company/CompanyTemplateSettings';
import Template from '@/orm/models/Company/Template';
import Article from '@/orm/models/Company/Article';
import CandidateTestAnswer from '@/orm/models/Candidate/CandidateTestAnswer';
import Vacancy from './models/Vacancy/Vacancy';
import VacancyContactPerson from './models/Vacancy/VacancyContactPerson';
import Address from './models/Address/Address';
import VacancyScript from './models/Interview/VacancyScript';
import Interviewer from './models/Interview/Interviewer';
import VacancyFaq from './models/Vacancy/VacancyFaq';
import VacancyFaqCommon from './models/Vacancy/VacancyFaqCommon';
import Skill from './models/Skill/Skill';
import User from './models/User/User';
import UserSettings from './models/User/Settings';
import Company from './models/Company/Company';
import CompanySettings from './models/Company/Settings';
import NotificationTemplate from './models/Company/NotificationTemplate/NotificationTemplate';
import NotificationTemplateSettings from './models/Company/NotificationTemplate/NotificationTemplateSettings';
import Logo from './models/Company/Logo';
import Resume from './models/Candidate/Resume';
import PublicToken from './models/Candidate/PublicToken';
import OfficePhoto from './models/Company/OfficePhoto';
import Candidate from './models/Candidate/Candidate';
import Interview from './models/Interview/Interview';
import CandidateLog from './models/Candidate/CandidateLog';
import CandidatePhoto from './models/Candidate/CandidatePhoto';
import CandidateTestScore from './models/Candidate/CandidateTestScore';
import OfficeInterview from './models/OfficeInterview/OfficeInterview';
import OfficeInterviewLog from './models/OfficeInterview/OfficeInterviewLog';
import InterviewLog from './models/Interview/InterviewLog';
import InterviewPreset from './models/Interview/InterviewPreset';
import InterviewVideoQuestionVideo from './models/Interview/InterviewVideoQuestionVideo';
import InterviewVideoCategoryVideo from './models/Interview/InterviewVideoCategoryVideo';
import Country from './models/Country/Country';
import Client from './models/Oauth/Client';
import InterviewImage from './models/Interview/InterviewImage';
import OfficeInterviewImage from './models/OfficeInterview/OfficeInterviewImage';
import InterviewPresetCategory from './models/Interview/InterviewPresetCategory';
import Profession from './models/Profession/Profession';
import Integration from './models/Integration/Integration';
import IntegrationVacancy from './models/Integration/IntegrationVacancy';
import Notification from './models/Notification/Notification';
import SystemNotification from './models/SystemNotification/SystemNotification';
import SystemNotificationSettings from './models/SystemNotification/SystemNotificationSettings';
import PayFrequency from './models/Dictionary/PayFrequency';
import CountryPayFrequency from './models/Country/CountryPayFrequency';
import Domain from './models/Domain/Domain';
import Statuses from './models/Candidate/Statuses';
import AiQuestion from './models/AiInterview/AiQuestion';
import Avatar from './models/AiInterview/Avatar';
import Referral from './models/Company/Referral';
import Discount from './models/Company/Discount';
import CandidateTest from './models/Candidate/CandidateTest';
import Test from './models/Test/Test';
import Question from './models/Test/Question';
import VacancyCandidatesCountByStatus from './models/Vacancy/VacancyCandidatesCountByStatus';
import MailTemplateEditor from './models/Company/NotificationTemplate/MailTemplateEditor';

const database = new Database();

database.register(User);
database.register(UserSettings);
database.register(Country);
database.register(Company);
database.register(CompanySettings);
database.register(Logo);
database.register(OfficePhoto);
database.register(NotificationTemplate);
database.register(NotificationTemplateSettings);
database.register(MailTemplateEditor);
database.register(Vacancy);
database.register(VacancySettings);
database.register(VacancyContactPerson);
database.register(Address);
database.register(VacancyScript);
database.register(Interviewer);
database.register(VacancyFaq);
database.register(VacancyFaqCommon);
database.register(Skill);
database.register(Candidate);
database.register(Interview);
database.register(InterviewPreset);
database.register(InterviewPresetCategory);
database.register(InterviewVideoQuestionVideo);
database.register(InterviewVideoCategoryVideo);
database.register(OfficeInterview);
database.register(CandidateLog);
database.register(CandidatePhoto);
database.register(CandidateTestScore);
database.register(OfficeInterviewLog);
database.register(InterviewLog);
database.register(Client);
database.register(Resume);
database.register(PublicToken);
database.register(InterviewImage);
database.register(OfficeInterviewImage);
database.register(Wizard);
database.register(Profession);
database.register(Integration);
database.register(IntegrationVacancy);
database.register(Notification);
database.register(SystemNotification);
database.register(SystemNotificationSettings);
database.register(Currency);
database.register(PayFrequency);
database.register(CountryCurrency);
database.register(CountryPayFrequency);
database.register(Account);
database.register(Plan);
database.register(Period);
database.register(Transaction);
database.register(BillingPayment);
database.register(PaymentMethod);
database.register(VacanciesList);
database.register(VacanciesListVacancies);
database.register(QuotaPrice);
database.register(Template);
database.register(CompanyTemplateSettings);
database.register(Article);
database.register(Domain);
database.register(Statuses);
database.register(AiQuestion);
database.register(Avatar);
database.register(Referral);
database.register(Discount);
database.register(CandidateTest);
database.register(Test);
database.register(Question);
database.register(CandidateTestAnswer);
database.register(VacancyCandidatesCountByStatus);

export default database;
